import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from './shared/services/auth.service';
import { LoadingSpinnerComponent } from './shared/components/loading-spinner/loading-spinner.component';
import { SessionStore } from './shared/stores/session.store';
import { SessionExpiryService } from './core/services/session-expiry.service';
import { ApplicationsService } from './features/mac/applications/services/applications.service';
import { DistributorService } from './features/mac/distributors/services/distributor.service';
import { TerminationService } from './features/mac/terminations/services/termination/termination.service';
import { CreditPlanService } from './features/plwc/credit-plans/services/credit-plan/credit-plan.service';
import { EmployeeService } from './features/portal/employees/services/employee/employee.service';
import { SupplierService } from './features/plwc/suppliers/services/supplier.service';

@Component({
  selector: 'app-root',
  imports: [RouterModule, LoadingSpinnerComponent],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss',
})
export class App implements OnInit {
  readonly auth = inject(AuthService);
  readonly sessionStore = inject(SessionStore);
  private readonly sessionExpiryService = inject(SessionExpiryService);
  private readonly applicationsService = inject(ApplicationsService);
  private readonly distributorService = inject(DistributorService);
  private readonly terminationService = inject(TerminationService);
  private readonly creditPlanService = inject(CreditPlanService);
  private readonly supplierService = inject(SupplierService);
  private readonly employeeService = inject(EmployeeService);

  ngOnInit(): void {
    this.auth.loadSession().subscribe();
  }
}
